import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Star, Phone } from "lucide-react";
import useDocumentTitle from "../lib/useDocumentTitle";

export default function Reviews() {
  useDocumentTitle("Customer Reviews", "Real reviews from HouseDesignWala™ customers across India — see what homeowners say about our house design and construction drawing service.");
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/reviews/all").then(r => setReviews(r.data)); }, []);

  return (
    <div>
      <section className="bg-[#FEF3E2] py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#F7941D]">Reviews</span>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold text-[#1a3c5e] mt-2">What Our Clients Say</h1>
          <p className="mt-3 text-gray-700">Real WhatsApp conversations from happy homeowners.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.id} className="bg-white rounded-2xl border border-[#1a3c5e]/10 shadow-sm overflow-hidden hover-lift">
              <div className="bg-[#075E54] text-white px-4 py-3 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center font-semibold text-sm">{r.reviewer_name?.[0]}</div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm">{r.reviewer_name}</div>
                  <div className="text-[11px] text-white/80">online</div>
                </div>
                <Phone className="w-4 h-4 opacity-70" />
              </div>
              <div className="bg-[#ECE5DD] px-4 py-5">
                <div className="ml-3 wa-bubble max-w-[95%]">
                  <p className="text-sm leading-relaxed">{r.review_text}</p>
                  <div className="text-[10px] text-gray-500 mt-1.5 text-right">10:24 AM <span className="text-blue-500">✓✓</span></div>
                </div>
              </div>
              <div className="bg-white px-4 py-3 flex items-center justify-between">
                <div>
                  <div className="font-semibold text-[#1a3c5e] text-sm">{r.reviewer_name}</div>
                  <div className="text-xs text-gray-500">{r.city}</div>
                </div>
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map(i => <Star key={i} className={`w-4 h-4 ${i <= r.rating ? "fill-[#F7941D] text-[#F7941D]" : "text-gray-300"}`} />)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
